import http from '@/util/http';

export default {
	//開啟VoLTE
	retrieveLteFlag() {
		return http.get('BasicSetting/api/lteFlagSwitch/retrieveLteFlag');
	},
	changeVoiceService(status){
		return http.get('BasicSetting/api/lteFlagSwitch/changeVoiceService', { params: { status }});
	},
	//快速復話
	validateArrear(){
		return http.get('BasicSetting/api/validateArrear');
	},
	applyQuickRestart(){
		return http.get('BasicSetting/api/applyQuickRestart');
	},
	//掛失/停話/復話
	getContractStatus(){
		return http.get('BasicSetting/api/getContractStatus');
	},
	changeContractStatus(selectedContractStatus){
		return http.get('BasicSetting/api/changeContractStatus', { params: { selectedContractStatus } });
	},
	// 撥打國際電話、撥打付費電話、撥打行動交友簡碼、去化保密、語中插接, service 為 limitOut, limitInside, mobileDatingShortCode, secretCall, callWaiting
	getVoiceBasicStatus(serviceID, service){
		return http.get('BasicSetting/api/' + service + '/getVoiceBasicStatus', { params: { serviceID } });
	},
	changeVoiceBasicStatus(applyStatus, serviceID, service){
		return http.get('BasicSetting/api/' + service + '/changeVoiceBasicStatus', { params: { applyStatus, serviceID } });
	},
	// //CommonView(撥打國際電話、撥打付費電話、撥打行動交友簡碼)
	// getVoiceBasicStatus(serviceID){
	// 	return http.get('BasicSetting/api/common/getVoiceBasicStatus', { params: { serviceID } });
	// },
	// changeVoiceBasicStatus(applyStatus, serviceID){
	// 	return http.get('BasicSetting/api/common/changeVoiceBasicStatus', { params: { applyStatus, serviceID } });
	// },
	//restriction's CommonView(去化保密、語中插接有權限設定，用這個api)
	// getVoiceBasicStatusRestrict(serviceID){
	// 	return http.get('BasicSetting/api/restriction/getVoiceBasicStatus', { params: { serviceID } });
	// },
	// changeVoiceBasicStatusRestrict(applyStatus, serviceID){
	// 	return http.get('BasicSetting/api/restriction/changeVoiceBasicStatus', { params: { applyStatus, serviceID } });
	// },
	//靜態頁面做權限驗證(指定轉接、查詢語音信箱、多方通話、數據用量提醒)
	permissionValidation() {
		return http.get('BasicSetting/api/staticView');
	}
}


// WEBPACK FOOTER //
// ./src/api/basicSetting/basicSettingApi.js